import React from 'react'

import Modal from 'common/Modal'
import Button from 'common/Button'
import ResellerForm from 'src/components/forms/SF/SF_resellers.js'

export default function ResellerModal({
  title = 'Become a Xeal reseller',
  text = 'Apply Now',
  arrow = false,
  btn = false,
  theme = '',
}) {
  return (
    <Modal
      trigger={
        <Button theme={theme} arrow={arrow} btn>
          {text}
        </Button>
      }
      title={title}
    >
      <ResellerForm />
    </Modal>
  )
}
